import { OddsFormat } from "../bullrun/enums.js";
const VALID_ODDS_FORMATS = new Set(Object.values(OddsFormat));
/**
 * Validate a value parsed from storage and return a typed
 * `Partial<PersistedAppSettings>`, or `undefined` if the shape is invalid.
 * Adapters should use this to guard against corrupted / legacy storage
 * payloads before handing them to `AppSettingsProvider`.
 */
export function parsePersistedAppSettings(raw) {
    if (!raw || typeof raw !== "object")
        return undefined;
    const candidate = raw;
    const result = {};
    if (typeof candidate.oddsFormat === "string" && VALID_ODDS_FORMATS.has(candidate.oddsFormat)) {
        result.oddsFormat = candidate.oddsFormat;
    }
    // Unknown/invalid fields are dropped silently; an empty result still
    // succeeds so callers fall through to defaults rather than erroring.
    return result;
}
